<template>
  <div>
    <div class="tutorial" v-show="tutorialData.length > 0">
      <div v-for="(value, index) in tutorialData" :key="index">
        <div class="coupon-content" v-if="index === current">
          <div class="coupon-img">
            <img :src="value"/>
          </div>
          <normal-btn @click="onNext">{{ tutorialData.length-1 === index ? 'プリクラONを使ってみる': '次へ' }}</normal-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import MaintenanceCheck from '../mixins/maintenancecheck';
import NormalBtn from '../components/NormalBtn';

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "Tutorial",
  components: {NormalBtn},
  mixins: [Protobuf, MaintenanceCheck],
  data () {
    return {
      current: 0,
      tutorialData: []
    }
  },
  watch: {
    '$route.params.type'() {
      this.current = 0
    }
  },
  methods: {
    onAppli() {
      window.open("https://app.adjust.com/j71pddb", "_blank")
    },
    onHome() {
      this.$router.push('/')
    },
    onNext() {
      if (this.current === this.tutorialData.length-1){
        this.$router.push("/")
        return
      }
      this.current++
      window.scrollTo(0,0)
    },
    onPrev() {
      this.current = this.current -1
      window.scrollTo(0,0)
    },
    // 利用規約に同意したか情報取得
    async getTermsOfServiceNo(){
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      return await this.post(cmdNo, encoded)
    },
    // ロード
    async getAgreedTermsInfo(){
      const cmdNo = pb.PlayerGeneralInformationReq.CommandNo.COMMAND_NO
      const message = pb.PlayerGeneralInformationReq.create({
        informationId: 1,
        isSave: false,
      })
      const encoded = pb.PlayerGeneralInformationReq.encode(message).finish()
      return await this.post(cmdNo, encoded)
    },
  },
  mounted(){
    this.maintenanceCheck();
    const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
    const message = pb.KumaMasterSettingReq.create({
      id: this.id
    })
    const encoded = pb.KumaMasterSettingReq.encode(message).finish()

    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS) {
          for (let index = 0; index < 5; index++) {
            const imgData = process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + decoded.masterTutorialList[index].imgPath;
            this.tutorialData.push(imgData);
          }
          // 利用規約同意しているかどうか
          if(this.$store.getters.isLogin){
            this.getAgreedTermsInfo().then(res => {
              this.getTermsOfServiceNo().then(res2 => {
                // 前回同意した利用規約No
                const intInformation = res.intInformation;
                // 今回の利用規約No
                const termsOfServiceNo = res2.termsOfServiceNo;
                if(termsOfServiceNo === intInformation){
                  // 利用規約同意済み
                  localStorage.setItem('isAgreedTerms', false);
                }else {
                  // 利用規約同意してない
                  localStorage.setItem('isAgreedTerms', true);
                }
              })
            })
          }
        } else {
          this.$_error('Error', { title: 'チュートリアル', statusCode: 100 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'チュートリアル', statusCode: 100 })
      })
  }
}
</script>

<style lang="scss" scoped>
.coupon-content {
  .coupon-img {
    padding-top: 45px;
    img { max-width: 100%; }
  }
  .NormalBtn { margin-top: 0; }
}
</style>
